import React, { useState, useEffect } from 'react';
import { useWeb3 } from '../contexts/Web3Context';
import { apiService } from '../services/api';
import './WalletConnect.css';

const WalletConnect: React.FC = () => {
  const { account, isConnected, connectWallet, disconnectWallet } = useWeb3();
  const [wallets, setWallets] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (isConnected && account) {
      loadWallets();
    }
  }, [isConnected, account]);

  const loadWallets = async () => {
    try {
      const userWallets = await apiService.getWallets();
      setWallets(userWallets);
    } catch (error) {
      console.error('Failed to load wallets:', error);
    }
  };

  const handleConnect = async () => {
    setLoading(true);
    setError(null);
    try {
      await connectWallet();
      if (account) {
        // Link wallet to user account
        try {
          await apiService.connectWallet(account);
          await loadWallets();
        } catch (err) {
          console.error('Failed to link wallet:', err);
          setError('Wallet connected but failed to link to account');
        }
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to connect wallet');
    } finally {
      setLoading(false);
    }
  };

  const handleDisconnect = () => {
    disconnectWallet();
    setWallets([]);
  };

  const formatAddress = (address: string) => {
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  };

  if (!isConnected) {
    return (
      <div className="wallet-connect">
        <button
          onClick={handleConnect}
          disabled={loading}
          className="connect-button"
        >
          {loading ? 'Connecting...' : 'Connect MetaMask'}
        </button>
        {error && <div className="error-message">{error}</div>}
      </div>
    );
  }

  const primaryWallet = wallets.find(w => w.isPrimary) || (wallets.length > 0 ? wallets[0] : null);
  const connectedWallet = wallets.find(w => w.address.toLowerCase() === account?.toLowerCase());

  return (
    <div className="wallet-connect">
      <div className="wallet-info">
        <span className="wallet-address">
          {account ? formatAddress(account) : 'Not connected'}
        </span>
        {connectedWallet && connectedWallet.isPrimary && (
          <span className="primary-badge">Primary</span>
        )}
        <button onClick={handleDisconnect} className="disconnect-button">
          Disconnect
        </button>
      </div>
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default WalletConnect;

